import fetch from "auth/FetchInterceptor";

const FacilityBankAnalysisService = {};

FacilityBankAnalysisService.getFacilityBankAnalysisService = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;

  const params = new URLSearchParams({
    pageSize: data.pageSize || 10,
    pageIndex: decrementIndex,
    facilityId: data.facilityId || "",
    status: data.status || "",
    customerId: data.customerId || "",
    branchId: data.branchId || "",
    status: "SU",
  });

  return fetch({
    url: `/FacilityBankAnalysis/searchList?${params.toString()}`,
    method: "get",
  });
};

FacilityBankAnalysisService.addFacilityBankAnalysisService = function (data) {
  return fetch({
    url: `/FacilityBankAnalysis/add`,
    method: "post",
    data: data,
  });
};

FacilityBankAnalysisService.addFacilityFinAnalysisService = function (data) {
  console.log("addFacilityFinAnalysisService", data);

  return fetch({
    url: `/FacilityFinAnalysis/add`,
    method: "post",
    data: data,
  });
};

FacilityBankAnalysisService.addFacilityCapitalAnalysisService = function (
  data
) {
  return fetch({
    url: `/FacilityCapitalAnalysis/add`,
    method: "post",
    data: data,
  });
};

FacilityBankAnalysisService.getCreditScoringFacItemService = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;

  const params = new URLSearchParams({
    pageSize: data.pageSize || 10,
    pageIndex: decrementIndex,
    facilityId: data.facilityId || "",
    customerId: data.customerId || "",
    branchId: data.branchId || "",
    startDate: data.startDate || "",
    endDate: data.endDate || "",
  });

  return fetch({
    url: `/CreditScoringFacItem/search?${params.toString()}`,
    method: "get",
  });
};

FacilityBankAnalysisService.posCreditScoringFacItemService = function (data) {
  return fetch({
    url: `/CreditScoringFacItem/calculate`,
    method: "post",
    data: data,
  });
};

FacilityBankAnalysisService.posCreditScoringFacSaveService = function (data) {
  return fetch({
    url: `/CreditScoringFacItem/save`,
    method: "post",
    data: data,
  });
};

FacilityBankAnalysisService.getSearchStepService = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;

  const params = new URLSearchParams({
    pageSize: data.pageSize || 10,
    pageIndex: decrementIndex,
    facilityid: data.facilityid || "", 
    applicationstep: data.applicationstep || "",  
    creditstepfacility: data.creditstepfacility || "", 
  });

  return fetch({
    url: `/APKFAS1/searchStep?${params.toString()}`,
    method: "get",
  });
};

FacilityBankAnalysisService.getGuarantorService = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;

  const params = new URLSearchParams({
    pageSize: data.pageSize || 10,
    pageIndex: decrementIndex,
    facilityid: data.facilityid || "", 
    status: data.status || "",   
  });

  return fetch({
    url: `/APKFAS2/search?${params.toString()}`,
    method: "get",
  });
};

FacilityBankAnalysisService.getColllateralService = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;

  const params = new URLSearchParams({
    pageSize: data.pageSize || 10,
    pageIndex: decrementIndex,
    facilityid: data.facilityid || "", 
    status: data.status || "",   
  });

  return fetch({
    url: `/APKFAS4/search?${params.toString()}`,
    method: "get",
  });
};

FacilityBankAnalysisService.getDeviasiService = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;

  const params = new URLSearchParams({
    pageSize: data.pageSize || 10,
    pageIndex: decrementIndex,
    facilityid: data.facilityid || "", 
    status: data.status || "",   
  });

  return fetch({
    url: `/APKFAS5/search?${params.toString()}`,
    method: "get",
  });
};

export default FacilityBankAnalysisService;
